// src/pages/ChapterEight.js
// Chapter 8 — Peacock Grove: Indian National Anthem (easy version in [brackets])
// Goal: Playing the anthem makes the peacocks (India’s national bird) stand tall.
// When they all stand, they reveal the GOLDEN STAR for the Star Quest.
// Update: Removed the problematic C4 in the last phrase and use a clean, easy-play range.
// Tip: Wherever the original uses a high B5, play the easy note [B] = B3 (low B).

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// ✅ Final easy/playable sequence (from your latest list), grouped into phrases.
// We keep only natural note names (plus C5) and use B3 (low B) where needed.
const anthemEasyLines = [
  // 1) C D E E E E E E E E E
  ["C", "D", "E", "E", "E", "E", "E", "E", "E", "E", "E"],
  // 2) D E F E E E D D D B3 D
  ["D", "E", "F", "E", "E", "E", "D", "D", "D", "B3", "D"],
  // 3) C C G G G G G G G G G
  ["C", "C", "G", "G", "G", "G", "G", "G", "G", "G", "G"],
  // 4) F A G F F F E E E D F
  ["F", "A", "G", "F", "F", "F", "E", "E", "E", "D", "F"],
  // 5) E B B C5 A A B G G A C
  ["E", "B", "B", "C5", "A", "A", "B", "G", "G", "A", "C"],
  // 6) C D D E E D E F
  ["C", "D", "D", "E", "E", "D", "E", "F"],
];

// Flatten for matching (the template also flattens internally; this is explicit)
const anthemEasyMelody = anthemEasyLines.flat();

// 🖼️ Story slides — keep “easy in [brackets]” guidance and GOLDEN STAR reveal after completion
const ChapterEightStory = [
  {
    image: "/images/ChapterEight/Ch8 Slide 1.png",
    text: "Pan and Wis reach Peacock Grove. The peacocks hush… waiting to hear a familiar tune.",
  },
  {
    image: "/images/ChapterEight/Ch8 Slide 2.png",
    text: "Peacocks are India’s national bird. When the anthem is played, they stand tall with pride.",
  },
  {
    image: "/images/ChapterEight/Ch8 Slide 3.png",
    text: "Somewhere among their feathers lies a GOLDEN STAR. It will only be revealed once the melody is finished.",
  },
  
  
    //image: "/images/notes/Anthem-Easy-Note-Card.png",
   // text: "Easy tip: if you ever see B5 in sheet versions, play the easy note [B] = B3 here. We also stay within C–C5.",


   // image: "/images/ChapterEight/Slide-4-Start-Melody.png",
   // text: "Begin softly. Keep every note even; let the anthem breathe. Use B3 for any high-B moments, and watch for C5.",
   // melody: true,
  

   // image: "/images/ChapterEight/Slide-5-Peacocks-Stand.png",
   // text: "As the anthem rises, the peacocks rise too—heads high, feathers shining.",


   // image: "/images/ChapterEight/Slide-6-Golden-Star-Reveal.png",
   // text: "Finish the melody to make every peacock stand. Only then will the GOLDEN STAR be revealed for the Star Quest.",

];

export default function ChapterEight() {
  return (
    <ChapterTemplate
      chapterNumber={8}
      chapterTitle="Peacock Grove — Indian National Anthem"
      sceneImageSrc="/images/ChapterEight/Ch8 Melody.png"
      storySlides={ChapterEightStory}
      targetMelody={anthemEasyMelody}
      melodyLines={anthemEasyLines}
      songTitle="Indian National Anthem (easy in [brackets])"
      companionsText={{
        wis:
          "Tip: Keep your tempo steady and your touch light. Use B3 for the easy [B], and aim cleanly for C5.",
        pan:
          "Beautiful! Stand tall with the peacocks—play it through and the golden star will appear. 🇮🇳⭐",
      }}
      // Doron remains asleep in Chapter 8.
      unlockNextChapterPath="/chapter-9"
    />
  );
}
